import styled from '@emotion/styled'

type PaletteCoreCenterProps = {
  color?: string
}

export default styled.div((props: PaletteCoreCenterProps) => ({
  label: 'PaletteCoreCenter',
  position: 'absolute',
  width: '45%',
  height: '45%',
  top: '27.5%',
  right: '27.5%',
  borderRadius: '50%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  transition: 'background-color .2s ease-in-out',
  backgroundColor: props.color,
}))
